import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "../../providers/auth0-instance";
import { withErrorNotification } from "../notifications";
import {
  getDetectionRequest,
  patchDetectionRequest,
  Detection,
} from "../../types";

export const detectionApi = createApi({
  reducerPath: "detectionApi",
  baseQuery: axiosBaseQuery(),
  tagTypes: ["detection"],
  endpoints: (builder) => ({
    getDetection: builder.query<Detection, getDetectionRequest>({
      query: ({ id }) => ({
        url: `/detection/${id}`,
        method: "GET",
      }),
      providesTags: ["detection"],
      onQueryStarted: withErrorNotification("Failed to fetch detection"),
    }),
    patchDetection: builder.mutation<Detection, patchDetectionRequest>({
      query: ({ id, data }) => ({
        url: `/detection/${id}`,
        method: "PATCH",
        data,
      }),
      invalidatesTags: ["detection"],
      onQueryStarted: withErrorNotification("Failed to update detection"),
    }),
  }),
});

export const { useGetDetectionQuery, usePatchDetectionMutation } = detectionApi;
